import BlockCover from '../plugins/BlockCover';

import Player = YT.Player;

export default function initHeaderVideo(): void {
  Alpine.data('headerVideo', () => ({
    youtubePlayer: null as Player | null,
    init() {
      if (this.$refs.video !== null
        && this.$refs.video.dataset.provider === 'YouTube'
        && document.querySelector(
          'script[src="https://www.youtube.com/iframe_api"]',
        ) === null) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
      }

      if (this.$refs.video !== null) {
        // @ts-expect-error: onYouTubeIframeAPIReady is not globally defined
        window.onYouTubeIframeAPIReady = () => {
          this.youtubePlayer = new YT.Player(this.$refs.video, {
            videoId: this.$refs.video.dataset.videoId,
            width: 1920,
            height: 1080,
            playerVars: {
              autoplay: 1,
              controls: 0,
              mute: 1,
              rel: 0,
              disablekb: 1,
              loop: 1,
              playlist: this.$refs.video.dataset.videoId,
            },
            events: {
              onReady: (event) => {
                event.target.playVideo();
                this.$refs.videoHolder.classList.add('opacity-100');
                if (this.$refs.video) {
                  // eslint-disable-next-line no-new
                  new BlockCover(this.$refs.video);
                }
              },
            },
          });
        };
      }
    },
  }));
}
